'use strict';

angular.module('far.models.event.status', [])
    .service('eventStatus', function () {
        var list = [{
            id: false,
            status: 'Черновик'
        }, {
            id: true,
            status: 'Одобрено'
        }];

        Object.defineProperty(this, 'list', {
            get: function () {
                return list;
            }
        });
    });